<template>
    <div>
        <div class="slotHeader">
            {{title}}
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccordionSection",
        props: {
            title: String
        }
    }
</script>

<style scoped>
    .slotHeader{
        display: flex;
        align-items: flex-end;
        padding:10px 1.5em;
        background: white;
        height: 40px;
        width: 100%;
        font-weight: bold;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }
    .content{
        padding: 1.5em;
    }
</style>